var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip-video-container"},[_c('div',{staticClass:"sys-max-width"},[_c('div',{staticClass:"ccc lg-mx"},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"text"},[_vm._v("当前账号为非授权账号，无法观看视频教程，请向管理员申请相关权限。")])])])])
}]

export { render, staticRenderFns }